module.exports = __webpack_public_path__ + "img/billionaire_0.35e01e47.jpg";